import Dexie from "dexie";

const db = new Dexie("SponsorApp");

db.version(2).stores({
  leads: "id, eventId, bookingId, detCode" // Primary key and indexed props
});

// db.version(1).stores({
// sponsors: 'id, eventId, sponsorCode, createdAt' // Primary key and indexed props
// });

db.version(2).stores({
  events: "uniqueId, eventId", // Primary key and indexed props
});

export const { leads } = db;
// export const {sponsors} = db;
export const { events } = db;
export default db;
